import { Alert, Button, Checkbox, Typography } from '@/shared/design-system';

import { KeyBackupActions, KeySavedConfirmation } from './wallet-mfa-settings.styled';

const KEY_SAVED_ID = 'wallet-totp-key-saved';

type WalletTotpBackupStepProps = {
  keySaved: boolean;
  onKeySavedChange: (_keySaved: boolean) => void;
  onCopy: () => void;
  onDownload: () => void;
};

export const WalletTotpBackupStep = ({
  keySaved,
  onKeySavedChange,
  onCopy,
  onDownload,
}: WalletTotpBackupStepProps) => (
  <>
    <Alert
      variant="error"
      title="Save your setup key now"
      description="It’s the only way to add your authenticator to a new phone. Gamma shows it once and can’t recover it. If you lose both your authenticator and this key, you can’t send funds or export your wallet, and we may not be able to restore access."
    />
    <KeyBackupActions>
      <Button size="sm" color="secondary" variant="subtle" onClick={onCopy}>
        Copy key
      </Button>
      <Button size="sm" color="secondary" variant="subtle" onClick={onDownload}>
        Download key
      </Button>
    </KeyBackupActions>
    <KeySavedConfirmation>
      <Checkbox
        id={KEY_SAVED_ID}
        checked={keySaved}
        onCheckedChange={(checked) => onKeySavedChange(checked === true)}
      />
      <Typography as="label" id={`${KEY_SAVED_ID}-label`} htmlFor={KEY_SAVED_ID} variant="body3">
        I saved my setup key somewhere safe, such as a password manager.
      </Typography>
    </KeySavedConfirmation>
  </>
);
